import { getMs } from '../../Helpers/utils';

export const isAuctionFinished = (card) => {
    return Date.now() >= getMs(card?.expired_at ?? 0);
};
